/** Stop tracks owned by a stream while retaining tracks reused by a replacement. */
export const stopUnsharedMediaTracks = (stream, keepStream = null) => {
    const keepTracks = new Set(keepStream?.getTracks?.() || []);
    stream?.getTracks?.().forEach((track) => {
        if (!keepTracks.has(track) && track.readyState !== "ended") track.stop();
    });
};
